import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'gatsby-plugin-intl';

import Config from '../../../config';
import Container from '../../layout/Container';
import { injectUser } from '../../session';
import { lang, translateLocal } from '../../../i18n';
import { withContext } from '../../Context/Context';
import { withLocation } from '../../../utils/withLocation';

import './CtaSticky.scss';

const CtaSticky = ({ authUser, context: { data: appContext }, onGetPassClick }) => {
  const { ctaSticky } = appContext.settings || {};

  if (!ctaSticky) {
    return null;
  }

  return (
    <>
      <div className="cta-sticky">
        <Container>
          <div className="content">
            <div className="head">{translateLocal(ctaSticky.title)}</div>
            <div className="text">{translateLocal(ctaSticky.text)}</div>
            {!!authUser && !authUser.isFullPassActive && !!appContext.settings.pricing && (!!appContext.settings.pricing.thrivePassPaymentUrl?.[lang] || !!appContext.settings.pricing.passPaymentUrl) ? (
              <Link
                to="/checkout/pass"
                className="button sm primary btn-cta-get-pass"
                onClick={onGetPassClick}
              >
                {translateLocal(ctaSticky.buttonLabel)}
              </Link>
            ) : (
              <Link
                to={Config.routePaths.getPass}
                className="button sm primary btn-cta-get-pass"
                onClick={onGetPassClick}
              >
                {translateLocal(ctaSticky.buttonLabel)}
              </Link>
            )}
          </div>
        </Container>
      </div>

      <div className="push" />
    </>
  );
};

CtaSticky.propTypes = {
  authUser: PropTypes.object,
  context: PropTypes.object.isRequired,
  onGetPassClick: PropTypes.func,
};

CtaSticky.defaultProps = {
  authUser: null,
  onGetPassClick: () => {},
};

export default withLocation(
  withContext(
    injectUser(
      CtaSticky,
    ),
  ),
);
